import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const getRakebacks = createAsyncThunk(
  "getRakebacks/getRakebacks",
  async (payload, thunkAPI) => {
    try {
      const response = await api.get("rakeback/get-rakebacks", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const getRakebacksSlice = createSlice({
  name: "getRakebacks",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRakebacks.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRakebacks.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getRakebacks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default getRakebacksSlice.reducer;
